import React from 'react'
import BalanceCard from '../Cards/BalanceCard';
import MobileMenu from './MobileMenu';
import MarketTabs from '../Markets/MarketTabs';
import Box from '@mui/material/Box';

const Index = () => {
  return (
    <Box
      sx={{
        minHeight: '100vh',
        bgcolor: 'background.default',
        color: 'text.primary',
        fontFamily: '"Source Sans 3", "Segoe UI", sans-serif',
        paddingBottom: '72px'
      }}
    >
      {/* Spacer for fixed header */}
      <Box sx={{ height: '64px' }} />

      {/* Total Balance Section */}
      <BalanceCard />

      {/* Quick Actions Section */}
      <MobileMenu />

      {/* Coin Prices Tabs */}
      <Box sx={{ px: 2, mt: 4, mb: 3, bgcolor: 'background.default' }}>
        <MarketTabs />
      </Box>

    </Box>
  )
}

export default Index
